import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function SQRAvailability({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    qr_providers: false,
  });

  // QR Providers (matching your Section 64 image)
  const QR_PROVIDERS = [
    // { name: "Maya SQR", field: "maya_sqr" },
    { name: "Maya P2P", field: "maya_p2p" },
    { name: "GCash SQR", field: "gcash_sqr" },
    // { name: "GCash DQR", field: "gcash_dqr" },
    { name: "GCash P2P", field: "gcash_p2p" },
    { name: "GCash Sound Box", field: "gcash_sound_box" },
    { name: "GCash Pocket POS", field: "gcash_pocket_pos" },
    // { name: "GCash Barcode", field: "gcash_barcode" },
    { name: "BDO Barcode Scanner", field: "bdo_barcode_scanner" },
    { name: "BDO SQR", field: "bdo_sqr" },
    { name: "BDO DQR", field: "bdo_dqr" }
  ];

  const OTHER_QR_PROVIDERS = [
    { name: "Shopee Pay", field: "qr_shopee_pay" },
    { name: "Alipay", field: "qr_alipay" },
    { name: "Union Pay", field: "qr_union_pay" },
    { name: "GrabPay", field: "qr_grabpay" },
    { name: "Atome", field: "qr_atome" },
    { name: "Booky Pay", field: "qr_booky_pay" },
    { name: "Hello Money", field: "qr_hello_money" },
    { name: "WeChat Pay", field: "qr_wechat_pay" },
    { name: "Plentina", field: "qr_plentina" },
    { name: "GoTyme", field: "qr_gotyme" }
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox") {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: checked
      }));
    } else {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    // Check if at least one QR provider is selected (Yes or No)
    const hasQRProviderSelection = QR_PROVIDERS.some(provider => 
      primaryDetails[`${provider.field}_yes`] || primaryDetails[`${provider.field}_no`]
    );
    
    if (!hasQRProviderSelection) {
      errors.qr_providers = true;
      toast.error("Please select at least one QR provider availability option", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    const hasQRProviderSelection = QR_PROVIDERS.some(provider => 
      primaryDetails[`${provider.field}_yes`] || primaryDetails[`${provider.field}_no`]
    );
    return hasQRProviderSelection;
  }
  const handleNext = () => {
    if (!validateForm()) return;

    // Build consolidated qr_provider from selected providers ("Yes")
    const selectedProviders = QR_PROVIDERS
      .filter(provider => primaryDetails[`${provider.field}_yes`])
      .map(provider => provider.name);

    // Build consolidated any_other_qr_provider from Other QR Providers ("Yes")
    const selectedOtherProviders = OTHER_QR_PROVIDERS
      .filter(provider => primaryDetails[`${provider.field}_yes`])
      .map(provider => provider.name);

    setPrimaryDetails(prev => ({
      ...prev,
      qr_provider: selectedProviders.length > 0 ? selectedProviders : undefined,
      any_other_qr_provider: selectedOtherProviders.length > 0 ? selectedOtherProviders : undefined,
    }));

    navigation.go("competitor-merch");
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">
                  SQR AVAILABILITY
                </h4>
                <p className="form-desc">
                  Section 64 of 110
                </p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">

                  <Form.Group className="mb-5" controlId="qr_providers">
                    <Form.Label className="form-label">
                      QR Providers <span className="form-required">*</span>
                    </Form.Label>

                    {/* Header Row */}
                    <div className="promo-grid-header">
                      <div>QR Provider</div>
                      <div className="text-center">Yes</div>
                      <div className="text-center">No</div>
                    </div>
                    {QR_PROVIDERS.map((provider, index) => (
                      <div key={index} className="promo-grid-row">
                        <div className="grid-item-name">
                          {provider.name}
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={provider.field}
                            value="yes"
                            checked={primaryDetails[`${provider.field}_yes`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${provider.field}_yes`]: e.target.checked,
                                [`${provider.field}_no`]: false
                              }));
                            }}
                          />
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={provider.field}
                            value="no"
                            checked={primaryDetails[`${provider.field}_no`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${provider.field}_no`]: e.target.checked,
                                [`${provider.field}_yes`]: false
                              }));
                            }}
                          />
                        </div>
                      </div>
                    ))}

                    {isError.qr_providers && (
                      <div className="form-error">
                        Please select QR provider availability options
                      </div>
                    )}
                  </Form.Group>

                  {/* Other QR Providers Section */}
                  <Form.Group className="mb-5" controlId="additional_qr_providers">
                    <Form.Label className="form-label">
                      Other QR Providers
                    </Form.Label>

                    {/* Header Row */}
                    <div className="form-radio-item" style={{
                      display: "grid",
                      gridTemplateColumns: "2fr 1fr 1fr",
                      gap: "1rem",
                      fontWeight: "600"
                    }}>
                      <div>QR Provider</div>
                      <div style={{ textAlign: "center" }}>Yes</div>
                      <div style={{ textAlign: "center" }}>No</div>
                    </div>

                    {/* Other QR Providers */}
                    {OTHER_QR_PROVIDERS.map((provider, index) => (
                      <div key={index} className="promo-grid-row">
                        <div className="grid-item-name">
                          {provider.name}
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={provider.field}
                            value="yes"
                            checked={primaryDetails[`${provider.field}_yes`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${provider.field}_yes`]: e.target.checked,
                                [`${provider.field}_no`]: false
                              }));
                            }}
                          />
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={provider.field}
                            value="no"
                            checked={primaryDetails[`${provider.field}_no`] || false}
                            onChange={(e) => {
                              setPrimaryDetails(prev => ({
                                ...prev,
                                [`${provider.field}_no`]: e.target.checked,
                                [`${provider.field}_yes`]: false
                              }));
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </Form.Group>

                  {/* Other QR provider free-text (optional) */}
                  <Form.Group className="mb-5" controlId="other_qr_provider">
                    <Form.Label className="form-label">
                      Other QR provider, if any
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="other_qr_provider"
                      value={primaryDetails.other_qr_provider || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                    Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SQRAvailability;
